// AppConst.js

export const UserClass = {
    etrace: {id: 0, name: "시스템관리자", rank: 0},
    homePlusAdmin: {id:1, name:"관리자", rank:10},
    master: {id:2, name:"통합운송(마스터)", rank:20},
    transPart: {id:3, name:"운송파트", rank:30},
    warehousePart: {id:4, name:"출고파트", rank:40},
    security: {id:5, name:"보안실(본사)", rank:50},
    store: {id:6, name:"점포", rank:100},
    transCompany: {id:7, name:"운송사", rank:200},
    transCompanyDriver: {id:8, name:"운전원", rank:300},
    stockManagePart: {id:9, name:"재고관리파트", rank:40},
};

export const TextToAuthClassId = {
    '관리자': '1',
    '통합운송': '2',
    '운송파트': '3',
    '출고파트': '4',
    '본사': '5',
    '점포': '6',
    '운송사': '7',
    '운전원': '8',
    '출고파트(EXP)': '9',
};

export const ApiMsg = {
    OK: "ok",
    AUTH_ERROR: "auth_error",
};

export const AppNumber = {
    MapHeaderHeight: 64,
    HeaderHeight: 100, MenuLeft: 150,
    ViewTabHeight: 30, // 2023.5.12
    dataContainerPadding: 10,
    SmallBoxPadding: 10,
    HeaderToolBoxHeight: 42,
    FooterHeight: 54, // from 52
    BigMinusTempLimit: -999999999,
    BigPlusTempLimit: 999999999,
    MinGoodTemp: -555,
    MaxGoodTemp: 555,
};

export const AppWord = {
    SMALL: 'small', MEDIUM:'medium', LARGE:'large', END: 'end', CENTER:'center',
    TOP:'top', LEFT:'left', RIGHT:'right', BOTTOM:'bottom',
    ALL: 'all', AllKorean: '전체',
    ChooseValue: '-', ChooseKorean: '선택',
    YMD_FOR_INPUT: 'YYYY-MM-DD',
    IgnoreAndClose: '무시하고 종료',
    ReloadNotInOneMinute: '1분 이내에는 재조회 할 수 없습니다',
    ReloadNotInHalfMinute: '30초 이내에는 재조회 할 수 없습니다',
    NOT_REAL_GPS_TIME: '2000-01-01 00:00:00',
    MAP_LOCALSTORAGE_KEY: 'mpHpLoStCfKeY',
    EV_MOUSE_MOVE: 'mousemove',EV_MOUSE_UP: 'mouseup',
    TSR_PRINT_SUB_URL: 'view=printtsr',
    MAP_SUB_URL: 'view=map',
    TSR_PRINT_WINDOW_NAME: 'tsrwin',
    MAP_WINDOW_NAME: 'homeplusmap',
    HMS_TAIL: ' 00:00:00',
    HMS_ZERO_TAIL: ' 00:00:00',
    HMS_END_TAIL: ' 23:59:59',
};

export const AppObject = {
    NoCachedFetch: {fetchPolicy: "no-cache"},
    NoCachedFetchToEdit: {fetchPolicy: "no-cache", edit:true},
    months: [
        '1월', '2월', '3월', '4월', '5월', '6월',
        '7월', '8월', '9월', '10월', '11월', '12월'
    ],
    weekChars: [ '일', '월', '화', '수', '목', '금', '토' ],
    emptyInputData: {data:{}, error:{}, hasError:false, changed: false, errorLabels:[]},
    NotImplementedAlert: {title:'알림', message:['구현되지 않은 기능입니다.', '관리자에게 문의하세요.'], isError:false},
    HomeMenu: {menu:{menuId:1,menuUrl:'home',menuName:'Home+',}, parentMenu:null},
    EmptyMenu: {menu:{}, parentMenu:null},
    EmptyViewerState: {open:false, item:null},
    command: {
        EDIT:'edit', VIEW:'view', NEW:'new', DELETE:'delete',
        MOVE:'move', STOP_USING:'stpuse', REUSE:'reuse',
        TRACE: 'trace', TRACEOFF:'traceoff', ROUTE: 'route', SET_ZONE: 'setzone',
        TO_MAP: 'map',
        CMD_SET_START:'set_r_start', CMD_SET_END:'set_r_end',
    },
    directionKorean16: [
        '북', '북북동', '북동', '동북동', '동', '동남동', '남동', '남남동',
        '남', '남남서', '남서', '서남서', '서', '서북서', '북서', '북북서'
    ],
    messageCancelEdit: {
        title: "작업 취소",
        content: [
            "입력한 내용이 있습니다.",
            "변경사항을 무시하고 작업을 종료하시겠습니까?"
        ],
    },
    alertNotWriter: {title: '허용되지 않은 작업', message: ['작성자만 수행할 수 있는 작업입니다.', '작성자에게 문의하세요.']},
    requestFlag: {
        /** TSR 발행여부 (운송요청 신규. 등록 (호차/운전자 저장)) 0*/
        REQ_STATE_FLAG_NEW : "0",
        /** TSR 발행여부 (TSR 저장/미발행) 1 */
        REQ_STATE_FLAG_SAVE : "1",
        /** TSR 발행여부 (TSR 발행) 2*/
        REQ_STATE_FLAG_TSR : "2",
    },
    YesNoCodeOptions: [
        {codeId: AppWord.ALL, codeName: AppWord.AllKorean},
        {codeId: 'Y', codeName: 'Y'},
        {codeId: 'N', codeName: 'N'},
    ]
};

export const AppStyle = {
    AppHeaderHeight: 60, AppFooterHeight: 45, AppViewTabHeight: 40,
    MainBackground:'#004343', TopMenuBorder: '1px solid #005353',
    HeaderBackgroundColor: '#170e78',
    HomeplusRed: '#E60014',
    PrimaryRGB:'#1976d2', WarnRGB: '#ed6c02', ErrorRGB: '#d32f2f', InfoRGB: '#0288d1', SecondaryRGB:'#9c27b0', SuccessRGB:'#2e7d32',
    NaverGreen: '#2db400',
    Button: {
        go: {backgroundColor:'#004343',color:'yellow'},
        warn: {backgroundColor:'#ff0000',color:'white', border:'1px solid black'},
        gray: {backgroundColor:'#cecece',color:'black'}
    },
    BorderCCC: '1px solid #cccccc',
    BorderEEE: '1px solid #eeeeee',
    HoverColor: '#e8e8f8',
    mui: {
        primary:'primary', info:'info', action:'action',
        success:'success', warning:'warning', error:'error',
        disabled:'disabled', secondary:'secondary', inherit:'inherit',
        contained:'contained', outlined: 'outlined', text:'text',
        standard:'standard'
    }
};

export const InputType = {
    text:'text', int:'int', float:'float', color:'color',
    date:'date', datetime:'datetime-local', time:'time',
    number: 'number',
    checkbox:'checkbox', password:'password', email:'email', url:'url', tel:'tel', month:'month',
    select:'select', //selectMulti:'selectMulti', selectMultiWithAdd:'selectMultiWithAdd',
    radio:'radio', radioForBoolean:'radioForBoolean',
};

export const MobileMenuId = {
    Home:'1000', // Home
    TransPlanState:'1100', // 배차현황
    TransPlan:'1200', // 운송요청 업로드
    TransPlanDownload:'1300', // 운송요청 조회
    TSR:'1400', // TSR 발행
    Store:'1500', // 점포관리
    VehTransPos:'1600', // 차량관제 리스트
    VehLocation:'1700', // 차량위치 리스트
    Report:'1800', // 리포트
    ManageRentTime:'1900', // 용차시간관리
    ManageRent:'1950', // 용차관리
    LogOut: '7', // 로그아웃
};

export const MenuUrl = {
    TopHome: '/stat',
    TransPlanStateForDc: '/planstat',// 배차현황
    TransPlanStateForCompany: '/plancom',// 배차현황 (운송사)
    TransPlanUpload: '/planup', // 운송요청 업로드 - Not used
    TransPlanLaunch: '/planlaunch', // 운송요청 조회
    TSR: '/tsr', // TSR 발행
    Store: '/store', // 점포관리
    VehTransPos: '/planpos', // 차량관제 리스트
    VehLocation: '/vehloc', // 차량위치 리스트
    Report: '/report', // 리포트 - Not used
    ManageRentTime: '/reporttime', // 용차시간관리
    ManageRent: '/rental', // 용차관리 -- Not used
    MaskDsc: '/maskdsc', // DC 전환.
};

export const UILabel = {
    buttonOk: '확인', buttonCancel: '취소', buttonClose: '닫기',
    buttonYes: '예', buttonNo: '아니오',
};

// Table
export const Selectable = { NO: 0, SINGLE: 1, MULTIPLE: 2 }; // 테이블의 체크박스에서 선택가능한 개수.
export const TableColumnType = {
    TEXT: 1, CHAR:2, INTEGER:10, FLOAT:11,
    DATE:20, DATETIME:21, HHMM_TEXT:22,
    ENUM:30, BOOLEAN: 31,
    GRAPH: 40, // Have to hav form(record, rowIndex) function in column definition.
};
export const TableRowMenu = { LIST:1, VIEW:2, NEW:3, EDIT:4, DELETE:5, CHECK:10, PLUS:11, MINUS:12 };

export const TopCode = {
    DcTypeCode: {General:'A', Fresh:'F', Express: 'E'},
    DcCode: {Adc982:'982'},
    ReqStateFlag: {
        NewRequest: '0', // 운송요청 신규등록 및 TSR 미저장
        TsrNotIssued: '1', // TSR 저장, TSR 미발행
        TsrIssued: '2', // TSR 발행
    },
    IrAction: {
        DC_DEP: 88, // DC 출발 버튼
        STORE_ARR: 85, // 점포도착 버튼
        STORE_DEP: 86, // 점포출발 버튼
        START_UNLOAD: 54, // 하차 시작 버튼
    }
};

export const CodeGroup = {
    ALLOC_FLAG_CD: 'ALLOC_FLAG_CD',
	ALLOC_TYPE_CD: 'ALLOC_TYPE_CD',
	ARRIVE_TIME_HH_GAP: 'ARRIVE_TIME_HH_GAP',
	AUTH_CD: 'AUTH_CD',
	AUTO_PLAN_ORDER_GROUP: 'AUTO_PLAN_ORDER_GROUP',
	AUTO_USE_YN_CD: 'AUTO_USE_YN_CD',
	BASIC_TIME_HH_GAP: 'BASIC_TIME_HH_GAP',
	BASIC_TIME_MM_GAP: 'BASIC_TIME_MM_GAP',
	BBS_TYPE_CD: 'BBS_TYPE_CD',
	BCD_EVENT_TYPE_CD: 'BCD_EVENT_TYPE_CD',
	CLIENT_ADDR_CD: 'CLIENT_ADDR_CD',
	DC_CD: 'DC_CD',
    DC_NO_RETURN_CD: 'DC_NO_RETURN_CD', // instead of NO_RETURN_CD
	DC_TYPE_CD: 'DC_TYPE_CD',
	FILE_CREATE_LIMIT_DAYS: 'FILE_CREATE_LIMIT_DAYS',
	FILE_DIRECTORY_CD: 'FILE_DIRECTORY_CD',
	FILE_DOWN_UP: 'FILE_DOWN_UP',
	FILE_FLAG: 'FILE_FLAG',
	GPS_USE_CD: 'GPS_USE_CD',
	GROUP: 'GROUP',
	HANDLER_YN_CD: 'HANDLER_YN_CD',
	HOMEPLUS_CUST_ID: 'HOMEPLUS_CUST_ID',
	HOMEPLUS_PWD: 'HOMEPLUS_PWD',
	HOMEPLUS_USER_ID: 'HOMEPLUS_USER_ID',
	ICON_GROUP_ID: 'ICON_GROUP_ID',
	INPU_ARR_TIME_CD: 'INPU_ARR_TIME_CD',
	IR_ACTION_CD: 'IR_ACTION_CD',
	IR_POI_TYPE_CD: 'IR_POI_TYPE_CD',
	LIMIT_STATE_CD: 'LIMIT_STATE_CD',
	LOG_CD: 'LOG_CD',
	NO_RETURN_CD: 'NO_RETURN_CD', // use DC_NO_RETURN_CD instead
	PHONE_AREA_CD: 'PHONE_AREA_CD',
	PHONE_SMART_CD: 'PHONE_SMART_CD',
	PIRE_TIME_INTERVAL_CD: 'PIRE_TIME_INTERVAL_CD',
	REG_TYPE_CD: 'REG_TYPE_CD',
	REQ_STATE_FLAG: 'REQ_STATE_FLAG',
	ROAD_RANK_CD: 'ROAD_RANK_CD',
	SERVER_ADDR_CD: 'SERVER_ADDR_CD',
	START_TIME_HH_GAP: 'START_TIME_HH_GAP',
	STORE_TYPE_CD: 'STORE_TYPE_CD',
	SVC_KEYPAD_CD: 'SVC_KEYPAD_CD',
	TEMPERATURE_CD: 'TEMPERATURE_CD',
	TRANS_FLAG: 'TRANS_FLAG',
	TRANS_PLAN_BIND_CD: 'TRANS_PLAN_BIND_CD',
	TRANS_TYPE_CD: 'TRANS_TYPE_CD',
	TRANS_VEH_TON_CD: 'TRANS_VEH_TON_CD',
	TRANS_VEH_TYPE_CD: 'TRANS_VEH_TYPE_CD',
	TSR_FILENAME_CD: 'TSR_FILENAME_CD',
	TSR_JSP_FILENAME_CD: 'TSR_JSP_FILENAME_CD',
	UPLOAD_SIZE_CD: 'UPLOAD_SIZE_CD',
	USER_BBS_CAT_CD: 'USER_BBS_CAT_CD',
	USER_BBS_STATUS_CD: 'USER_BBS_STATUS_CD',
	USE_YN_CD: 'USE_YN_CD',
	VEH_TYPE_CD: 'VEH_TYPE_CD',
	VEH_TYPE_GP_CD: 'VEH_TYPE_GP_CD',
};

/*
Group codes:
ALLOC_FLAG_CD
ALLOC_TYPE_CD
ARRIVE_TIME_HH_GAP
AUTH_CD
AUTO_PLAN_ORDER_GROUP
AUTO_USE_YN_CD
BASIC_TIME_HH_GAP
BASIC_TIME_MM_GAP
BBS_TYPE_CD
BCD_EVENT_TYPE_CD
CLIENT_ADDR_CD
DC_CD
DC_TYPE_CD
FILE_CREATE_LIMIT_DAYS
FILE_DIRECTORY_CD
FILE_DOWN_UP
FILE_FLAG
GPS_USE_CD
GROUP
HANDLER_YN_CD
HOMEPLUS_CUST_ID
HOMEPLUS_PWD
HOMEPLUS_USER_ID
ICON_GROUP_ID
INPU_ARR_TIME_CD
IR_ACTION_CD
IR_POI_TYPE_CD
LIMIT_STATE_CD
LOG_CD
NO_RETURN_CD
PHONE_AREA_CD
PHONE_SMART_CD
PIRE_TIME_INTERVAL_CD
REG_TYPE_CD
REQ_STATE_FLAG
ROAD_RANK_CD
SERVER_ADDR_CD
START_TIME_HH_GAP
STORE_TYPE_CD
SVC_KEYPAD_CD
TEMPERATURE_CD
TRANS_FLAG
TRANS_PLAN_BIND_CD
TRANS_TYPE_CD
TRANS_VEH_TON_CD
TRANS_VEH_TYPE_CD
TSR_FILENAME_CD
TSR_JSP_FILENAME_CD
UPLOAD_SIZE_CD
USER_BBS_CAT_CD
USER_BBS_STATUS_CD
USE_YN_CD
VEH_TYPE_CD
VEH_TYPE_GP_CD
*/



// ############ Naver Map ###########

export const MapEvent = {
    CLICK:'click', RIGHT_CLICK:'rightclick', DOUBLE_CLICK:'dblclick', MOUSE_UP: 'mouseup',
    DRAG_START:'dragstart', DRAG:'drag',DRAG_END:'dragend',
    ZOOM_CHANGED:'zoom_changed', BOUNDS_CHANGED: 'bounds_changed',
    MOUSE_OVER:'mouseover', MOUSE_OUT:'mouseout',
    IDLE: 'idle', CENTER_CHANGED: 'center_changed'
}; //mousedown, mouseup, click, dblclick, rightclick, mouseover, mouseout, mousemove

export const MapValue = {
    NaverService: 'naver',
    NaverSearchRouteURL: 'https://naveropenapi.apigw.ntruss.com/map-direction/v1/driving',
    Korea: { East: 132, West: 124, South: 33, North: 39 },
    MarkerType: {VEH_POS:1, ROUTE_POINT:2, POI:3, CLUSTER:4, START:11, END:12, INFO:21,},
    MapEvent: {PopInfoBox:'popinfo', SetRoutePoint:'naverroutepoint'},
    MapInitEvent: {
        showVehicle: 'sv', showRoute: 'rt', showPoi: 'poi', traceVehicle: 'trv',
    },
    LABEL_CONTAINER_WIDTH: 70, // 마커 라벨상자 폭. css poi-marker와 맞춰야 함.
    MARKER_LABEL_HEIGHT: 22, // 마커 라벨 높이
    USER_DATA: 'userData',
    POI_ICON_DIR: 'img', // 'poi_icon',
    NEWTOP_POI_ICON_DIR: 'img',
    VEH_ICON_DIR: 'img/marker/',
    MISC_DIR: 'img/misc/',
    CLUSTER_Z_INDEX:99900000,
    POI_Z_INDEX:99990000,
    VEHPOS_Z_INDEX:99999900,
    ROUTE_Z_INDEX:99999990,
    ClusterIconSize: 44, // in pixel
    ClusterCoverSize: 110, // in pixel
    Level: {
        ZOOM_INIT: 15,
        ZOOM_MIN: 7, // Default 6 - 한반도 (내 노트북에서 볼 때)
        ZOOM_MAX: 21, // Default 21 - 골목
        ZOOM_FOR_ROUTE_POINT: 16,
        MAX_FOR_CLUSTER: 15,
    },
    POS_MARKER_SIZE: 22,
    POS_MARKER_HIGHT: 46, // MARKER_LABEL_HEIGHT + POS_MARKER_SIZE
    ROUTE_MARKER_SIZE: 12,
    /* NaverMapTyles: [
        {type: window.naver.maps.MapTypeId.NORMAL, label: '일반', title: '일반지도'},
        {type: window.naver.maps.MapTypeId.TERRAIN, label: '지형', title: '지형지도'},
        {type: window.naver.maps.MapTypeId.SATELLITE, label: '위성', title: '위성지도'},
        {type: window.naver.maps.MapTypeId.HYBRID, label: '겹침', title: '겹침지도'},
    ], */
    LevelOptions: [
        {level:7, label:'레벨 7-전국 수준'}, // 기존UI: 레벨 0
        {level:8, label:'레벨 8'},
        {level:9, label:'레벨 9'},
        {level:10, label:'레벨 10'},
        {level:11, label:'레벨 11-도 수준'},
        {level:12, label:'레벨 12'},
        {level:13, label:'레벨 13'},
        {level:14, label:'레벨 14-시 수준'}, // default
        {level:15, label:'레벨 15'},
        {level:16, label:'레벨 16'},
        {level:17, label:'레벨 17'},
        {level:18, label:'레벨 18-동 수준'},
        {level:19, label:'레벨 19'},
        {level:20, label:'레벨 20'},// 기존UI: 레벨 13
        {level:21, label:'레벨 21-빌딩,거리 수준'} 
    ],
    NaverTrackOption: [
        {value:'trafast',		label:'실시간 빠른길'},
        {value:'tracomfort',	label:'실시간 편한길'},
        {value:'traoptimal',	label:'실시간 최적'},
        {value:'traavoidtoll',	label:'무료 우선'},
        {value:'traavoidcaronly',label:'자동차 전용도로 회피 우선'}
    ],
    NaverTrackMethod: {
        Fast: 'trafast',
        Comfort: 'tracomfort',
        Optimal: 'traoptimal',
        //NoToll: 'traavoidtoll',
        //NotDedicated: 'traavoidcaronly',
    },
    PopupOption: 'left=1,top=1,menubar=0,status=1,toolbar=0,scrollbars=0,resizable=yes',
    Job: {
        ShowTruck: 'showtruck',
    },
}

/*
동단
경상북도 울릉군 울릉읍 독도리 동도. 북위 37° 14′ 24″ 동경 131° 52′ 22″[1]
서단
인천광역시 옹진군 백령면 연화리. 북위 37° 58′ 10″ 동경 124° 36′ 36″[1]
남단
제주특별자치도 서귀포시 대정읍 마라리. 북위 33° 06′ 43″ 동경 126° 16′ 07″[1]
북단
강원도 고성군 현내면 대강리 북위 38° 36′ 40″ 동경 128° 21′ 51″[2]
*/
